import React from 'react'
import { getIn } from 'formik'
import { SelectCenter as BsSelectCenter } from 'bs-unified-ui'

interface SelectCenterProps {
  form?: any
  field: any
  onChange: (e) => void
  onBlur: () => void
  disabled: boolean
}

const SelectCenter: React.FC<SelectCenterProps> = ({
  form,
  field,
  onChange,
  onBlur,
  disabled,
  ...props
}) => (
  <BsSelectCenter
    {...field}
    onChange={(newValue) => {
      onChange(newValue)
      form.setFieldValue(field.name, newValue)
    }}
    onBlur={() => {
      onBlur()
      form.validateField(field.name)
    }}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

SelectCenter.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  disabled: false,
}

export default SelectCenter
